import { Routes } from "@angular/router";
import { PagesComponent } from "./pages.component";
import { ProducersComponent } from "./producers/producers.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { ProducerDetailComponent } from "./producers/producer-detail/producer-detail.component";
import { maintenanceGuard } from "../shared/guards/auth-guard.guard";
import { BlogComponent } from "./blog/blog.component";
import { BlogPostComponent } from "./blog/blog-post/blog-post.component";
import { ProductsComponent } from "./about-us/products/products.component";
import { FamilyTeamComponent } from "./about-us/family-team/family-team.component";
import { OurGuidingPrinciplesComponent } from "./about-us/our-guiding-principles/our-guiding-principles.component";
import { SchoolFieldTripsComponent } from "./school-field-trips/school-field-trips.component";
import { OnFarmStoreComponent } from "./on-farm-store/on-farm-store.component";
import { CornMazeComponent } from "./corn-maze/corn-maze.component";
import { DirectionsToFarmComponent } from "./directions-to-farm/directions-to-farm.component";
import { AtlantaDeliveryScheduleComponent } from "./atlanta-delivery-schedule/atlanta-delivery-schedule.component";
import { FaqComponent } from "./faq/faq.component";
import { OurStoryComponent } from "./our-story/our-story.component";
import { GiftCardsComponent } from "./gift-cards/gift-cards.component";
import { HowItWorksComponent } from "./how-it-works/how-it-works.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";

export const pagesRoutes: Routes = [
  {
    path: 'pages',
    title: 'Pages',
    component: PagesComponent,
    canActivate: [maintenanceGuard],
    canActivateChild: [maintenanceGuard],
    children: [
      {
        path: 'how-it-works',
        title: 'How it works',
        component: HowItWorksComponent
      },
      {
        path: 'products',
        title: 'Products',
        component: ProductsComponent
      },
      {
        path: 'family-and-team',
        title: 'Family & Team',
        component: FamilyTeamComponent
      },
      {
        path: 'our-guiding-principles',
        title: 'Our Guiding Principles',
        component: OurGuidingPrinciplesComponent
      },
      {
        path: 'faq',
        title: 'FAQ',
        component: FaqComponent,
      },
      {
        path: 'producers',
        title: 'Producers',
        component: ProducersComponent
      },
      {
        path: 'producers/:producerUrl',
        title: 'Producer Detail',
        component: ProducerDetailComponent
      },
      {
        path: 'contact-us',
        title: 'Contact Us',
        component: ContactUsComponent
      },
      {
        path: 'blog',
        title: 'Blog',
        component: BlogComponent
      },
      {
        path: 'blog-post/:category/:title',
        title: 'Blog Post',
        component: BlogPostComponent
      },
      {
        path: 'gift-cards',
        title: 'Gift Cards',
        component: GiftCardsComponent
      },
      {
        path: 'corn-maze',
        title: 'Corn Maze',
        component: CornMazeComponent
      },
      {
        path: 'on-farm-store',
        title: 'On-Farm Store',
        component: OnFarmStoreComponent
      },
      {
        path: 'school-field-trips',
        title: 'School Field Trips',
        component: SchoolFieldTripsComponent
      },
      {
        path: 'atlanta-delivery-schedule',
        title: 'Atlanta Delivery Schedule',
        component: AtlantaDeliveryScheduleComponent
      },
      {
        path: 'directions-to-the-farm',
        title: 'Directions to the Farm',
        component: DirectionsToFarmComponent
      },
      {
        path: 'our-story',
        title: 'Our Story',
        component: OurStoryComponent
      },
      {
        path: 'privacy-policy',
        title: 'Privacy Policy',
        component: PrivacyPolicyComponent
      },
    ]
  },
];
